import { TextInput as BaseTextInput } from '@mantine/core';
import { forwardRef } from 'react';

interface TextInputProps {
  name?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: any;
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  disabled?: boolean;
  value?: string;
  icon?: React.ReactNode;
  rightSection?: React.ReactNode;
}

export default forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      name,
      label,
      placeholder,
      required,
      error,
      onChange,
      onFocus,
      onBlur,
      disabled,
      value,
      icon,
      rightSection,
    },
    ref
  ) => {
    return (
      <BaseTextInput
        ref={ref}
        name={name}
        icon={icon}
        label={label}
        required={required}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={event => onFocus?.(event)}
        onBlur={event => onBlur?.(event)}
        error={error?.message}
        disabled={disabled}
        value={value}
        rightSection={rightSection}
      />
    );
  }
);
